import { render, staticRenderFns } from "./FormulaAdmissionScoreCoefficientIndex.vue?vue&type=template&id=4f86aadb&"
import script from "./FormulaAdmissionScoreCoefficientIndex.vue?vue&type=script&lang=js&"
export * from "./FormulaAdmissionScoreCoefficientIndex.vue?vue&type=script&lang=js&"
import style0 from "./FormulaAdmissionScoreCoefficientIndex.vue?vue&type=style&index=0&id=4f86aadb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports